import 'rc-collapse/assets/index.css';
import React from 'react';
import * as DocumentStorageActions from '../actions/documentStorage'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl';
import ModalFormStorageAdd from './forms/ModalFormStorageAdd.react';
import objectPath from 'object-path';

class DashboardNew extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalFormOpen: false,
            modalFormDocuments: [],
            modalFormSelectedDocument: null,
            campaignGroupCollapsed: [],
            campaignCollapsed: [],
            search: '',
        };

        // React components using ES6 classes no longer autobind this to non React methods. In your constructor, add:
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addStorage = this.addStorage.bind(this);
    };

    static get defaultProps() {
        return {
            campaign: []
        }
    }

    openDocument(campaign, document = null) {
        if (document && document.downloadableDocumentUrl !== null) {
            window.open(document.downloadableDocumentUrl, '_blank');
        } else {
            this.openModal(campaign, (document ? document.raw : null));
        }
    }

    openModal(campaign, document = null) {

        let oldState = this.state;

        let newState = {
            ...oldState,
            modalFormOpen: true,
            modalFormDocuments: campaign.documents,
            modalFormSelectedDocument: document
        };

        this.setState(newState);
    }

    closeModal() {
        this.setState({ modalFormOpen: false });
    }

    addStorage(title, document, locale, pricingField) {
        this.closeModal();
        let { dispatch } = this.props;
        dispatch(DocumentStorageActions.createDocumentStorage(title, document, locale, pricingField, true));
    }

    prepareCreationData(campaignGroups) {

        const intl = this.props.intl;
        const currentLocale = intl.locale.replace('-', '_'); // de-DE -> de_DE

        let groups = [];

        campaignGroups.map((group, i) => {

            let groupTitle = objectPath.get(group, 'translationsSorted.' + currentLocale + '.name');
            if (!groupTitle) {
                groupTitle = objectPath.get(group, 'name');
            }

            let _group = {
                id: i,
                title: groupTitle,
                campaigns: []
            };

            group.campaigns.map((campaign, ii) => {

                let campaignTitle = objectPath.get(campaign, 'translationsSorted.' + currentLocale + '.name', null);
                if (!campaignTitle) {
                    campaignTitle = campaign.name;
                }

                let campaignDescription = objectPath.get(campaign, 'translationsSorted.' + currentLocale + '.description', null);
                if (!campaignDescription) {
                    campaignDescription = '';
                }

                let _campaign = {
                    id: campaign.id,
                    raw: campaign,
                    title: campaignTitle,
                    description: campaignDescription,
                    image: null,
                    infoPdf: campaign.infoPdf,
                    infoPdfTitle: campaign.infoPdfTitle,
                    documents: []
                };

                if (campaign.image) {
                    _campaign.image = campaign.image;
                }

                campaign.documents.map((document, iii) => {

                    let _document = {
                        raw: document,
                        id: document.id,
                        title: document.name,
                        image: null,
                        downloadableDocumentUrl: null,
                    };

                    const isDownloadableDocument = objectPath.get(document, 'isDownloadableDocument', false);
                    const downloadableDocument = objectPath.get(document, 'translationsSorted.' + currentLocale + '.downloadableDocument', null);
                    if (isDownloadableDocument !== false && downloadableDocument !== null) {
                        _document.downloadableDocumentUrl = downloadableDocument;
                    }

                    let documentTitle = objectPath.get(document, 'translationsSorted.' + currentLocale + '.name', null);
                    if (documentTitle) {
                        _document.title = documentTitle;
                    }

                    if (document.image) {
                        _document.image = document.image
                    }

                    _campaign.documents.push(_document);
                });

                if (_campaign.documents.length > 0) {
                    _group.campaigns.push(_campaign);
                }

            });

            if (_group.campaigns.length > 0) {
                groups.push(_group);
            }

        });

        const searchString = this.state.search.toLowerCase();

        if (searchString === '') {
            return groups;
        } else {
            let filteredGroups = [];
            groups.map(group => {

                // if string in groupname, we show the group with all campaings and documents!
                if (group.title.toLowerCase().indexOf(searchString) >= 0) {
                    filteredGroups.push(group);
                    return;
                }

                let filteredCampaigns = [];
                group.campaigns.map(campaign => {

                    // if string in campaign, we show the campaign with all documents
                    if (campaign.title.toLowerCase().indexOf(searchString) >= 0 || campaign.description.toLowerCase().indexOf(searchString) >= 0) {
                        filteredCampaigns.push(campaign);
                        return;
                    }

                    let filteredDocuments = [];
                    campaign.documents.map(document => {
                        // if string in document, we show the document
                        if (document.title.toLowerCase().indexOf(searchString) >= 0) {
                            filteredDocuments.push(document);
                            return;
                        }
                    });
                    if (filteredDocuments.length > 1) {
                        campaign.documents = filteredDocuments;
                        filteredCampaigns.push(campaign);
                        this.state.campaignCollapsed.push(campaign.id);
                        return;
                    }
                });

                if (filteredCampaigns.length > 0) {
                    group.campaigns = filteredCampaigns;
                    filteredGroups.push(group);
                    this.state.campaignGroupCollapsed.push(group.id);
                    return;
                }

            });

            return filteredGroups;
        }

    }


    collapseCampaignGroup(groupId) {

        let campaignGroupCollapsed = this.state.campaignGroupCollapsed;

        let containsGroupAlready = false;

        for (let i = 0; i < campaignGroupCollapsed.length; i++) {
            if (campaignGroupCollapsed[i] == groupId) {
                containsGroupAlready = true;
                campaignGroupCollapsed.splice(i, 1);
            }
        }

        if (!containsGroupAlready) {
            campaignGroupCollapsed.push(groupId);
        }

        this.setState({ campaignGroupCollapsed: campaignGroupCollapsed });
    }

    collapseCampaignDocuments(campaignId) {

        let campaignCollapsed = this.state.campaignCollapsed;

        let containsCampaignAlready = false;

        for (let i = 0; i < campaignCollapsed.length; i++) {
            if (campaignCollapsed[i] == campaignId) {
                containsCampaignAlready = true;
                campaignCollapsed.splice(i, 1);
            }
        }

        if (!containsCampaignAlready) {
            campaignCollapsed.push(campaignId);
        }

        this.setState({ campaignCollapsed: campaignCollapsed });
    }

    handleSearch(event) {
        event.preventDefault();
        this.state.campaignGroupCollapsed = [];
        this.state.campaignCollapsed = [];
        this.setState({
            search: event.target.value,
        })
    }

    render() {

        // get campaigns from state
        const campaigns = this.props.campaign.data;
        const fallbackImageLink = '/files/misc/thumbnail_fallback.png';
        // prepare data
        const groups = this.prepareCreationData(campaigns);

        let campaignGroupCollapsed = this.state.campaignGroupCollapsed;
        let campaignCollapsed = this.state.campaignCollapsed;

        const searchString = this.state.search.toLowerCase();

        let searchField = null;
        if ((searchString === '' && groups.length > 0) || searchString !== '') {
            searchField =
                <FormattedMessage id="LABEL_SEARCH">
                  {(message) => (
                      <div id="document-search" className="input-group">
                          <div className="input-group-addon"><FormattedMessage id="LABEL_SEARCH_ADDON" /></div>
                          <input type="text" className="form-control" placeholder={message} value={this.state.search} onChange={this.handleSearch.bind(this)}/>
                      </div>
                  )}
                </FormattedMessage>
        }

        return (

            <div className="panel panel-default">
                <div className="panel-heading">
                    <h2 className="panel-title"><FormattedMessage id="LABEL_CREATE_NEW_STORAGE" /></h2>
                </div>
                { searchField }
                <div className="panel-body campaign-list">
                    {
                        groups.map((group, i) => {

                            const groupKey = 'group-' + i;
                            let isOpen = false, showGroup, collapseButtonClass = 'btn btn-info campaign-group-btn', collapseButtonIcon = 'view_module';

                            for (let i = 0; i < campaignGroupCollapsed.length; i++) {
                                if (campaignGroupCollapsed[i] == group.id) {
                                    isOpen = true;
                                }
                            }

                            if (isOpen == true) {
                                collapseButtonClass = 'btn btn-info active campaign-group-btn';
                                collapseButtonIcon = 'close';
                            }

                            return <div key={groupKey}>
                                <div className="row">
                                    <a onClick={() => this.collapseCampaignGroup(group.id)} role="button" className={collapseButtonClass}>{group.title}<i className="material-icons collapse-campaign-icon">{collapseButtonIcon}</i></a>
                                    <div className="panel panel-default" style={{ display: isOpen ? 'block' : 'none' }}>
                                        {
                                            group.campaigns.map((campaign, ii) => {

                                                let campaignImage = null;
                                                let campaignPdf = null;
                                                if (campaign.image) {
                                                    campaignImage = <img src={campaign.image} className="campaign-thumbnail shadow" />
                                                } else {
                                                    campaignImage = <img src={fallbackImageLink} className="campaign-thumbnail shadow" />
                                                }
                                                if (campaign.infoPdf) {
                                                    campaignPdf = <a href={campaign.infoPdf}
                                                        target="_blank"><FormattedMessage id="LABEL_PRINT_SPECIFICATION" />:<br />{campaign.title}</a>;
                                                }

                                                // campaign key
                                                const campaignKey = 'campaign-' + ii;

                                                // CSS class variables
                                                let campaignDocumentsContainerClass, collapseButtonClass = 'btn btn-info', collapseButtonIcon = 'view_module';

                                                let isOpen = false;

                                                for (let i = 0; i < campaignCollapsed.length; i++) {
                                                    if (campaignCollapsed[i] == campaign.id) {
                                                        isOpen = true;
                                                    }
                                                }

                                                if (isOpen == true) {
                                                    campaignDocumentsContainerClass = 'campaign-documents open';
                                                    collapseButtonClass = 'btn btn-info active';
                                                    collapseButtonIcon = 'close';
                                                } else {
                                                    campaignDocumentsContainerClass = 'campaign-documents';
                                                }

                                                var collapeButton = <a onClick={() => this.collapseCampaignDocuments(campaign.id)} role="button" className={collapseButtonClass}>
                                                    <i className="material-icons">{collapseButtonIcon}</i>
                                                    <FormattedMessage id="LABEL_CHOOSE_DOCUMENT" />
                                                </a>;

                                                if (campaign.documents.length == 0) {
                                                    collapeButton = '';
                                                }

                                                return <div className="campaign clearfix" key={campaignKey}>
                                                    <div className="campaign-description">
                                                        <div>
                                                            <div>
                                                                {campaignImage}
                                                            </div>
                                                            <div className="campaign-text">
                                                                <h4>{campaign.title}</h4>
                                                                <p>{campaign.description}</p>
                                                                <p>{campaignPdf}</p>
                                                                <p>{collapeButton}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={campaignDocumentsContainerClass}>
                                                        {
                                                            campaign.documents.map((document, iii) => {
                                                                const documentKey = 'document-' + iii;
                                                                let documentImage = null;
                                                                if (document.image) {
                                                                    documentImage = <img src={document.image} className="campaign-thumbnail shadow" />
                                                                }
                                                                return <div onClick={() => this.openDocument(campaign.raw, document)} className="campaign-document" key={documentKey}>
                                                                    <div>
                                                                        {documentImage}
                                                                        <p>{document.title}</p>
                                                                    </div>
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            })
                                        }

                                    </div>
                                </div>
                            </div>
                        })
                    }

                    <ModalFormStorageAdd
                        closeModal={this.closeModal}
                        isOpenModal={this.state.modalFormOpen}
                        documents={this.state.modalFormDocuments}
                        selectedDocument={this.state.modalFormSelectedDocument}
                        addStorage={this.addStorage} />

                </div>
            </div>
        );
    }
}

export default connect(state => ({ documentStorage: state.documentStorage }))(injectIntl(DashboardNew));



// WEBPACK FOOTER //
// ./src/js/components/DashboardNew.react.jsx